import { useEffect, useState } from 'react';
import { UserAuth } from '../../context/AuthContext';
import { useUI } from '../../hooks/usePermission';
import useSSE from '../../utils/useSSE';
import strings from "../../locales/ro.json";
import config from '../../config';

import "./Handrules.css"
import HeaderElement from "../../components/HeaderElement/HeaderElement";
import HandrulesBox from "../../components/Handrules/HandrulesBox/HandrulesBox"
import HandrulesButtons from "../../components/Handrules/HandrulesButtons/HandrulesButtons"
import { useApi } from "../../hooks/useApi";
import StandardPopup from "../../components/Global/StandardPopup/StandardPopup";
import pencil from "../../assets/icons/pencil.svg";
import errorIcon from "../../assets/icons/eroare-404.svg";
import TehnicLock from '../../components/Handrules/TehnicLock/TehnicLock';

const Handrules = () => {
	const { user } = UserAuth();
	const { api } = useApi();
	const canManageHandrules = useUI('action.handrules.manage');
	const [editMode, setEditMode] = useState(false);
	const [showErrorModal, setShowErrorModal] = useState(false);
	const [apiError, setApiError] = useState(false);

	const [canConnectSSE, setCanConnectSSE] = useState(false);

	useEffect(() => {
		if (canManageHandrules && user?.accessToken) {
			api(`handrules/${config.handrulesLobbyId}`, "PUT")
				.then(() => setCanConnectSSE(true))
				.catch((error) => {
					if (error.status === 409 || (error.message && error.message.includes("409")) || (error.message && error.message.includes("Lobby already exists"))) {
						setCanConnectSSE(true);
						return; 
					}
					console.error("Error updating handrules:", error);
					setApiError(true);
					setShowErrorModal(true);
				});
		} else if (!canManageHandrules && user?.accessToken) {
			setCanConnectSSE(true);
		}
	}, [canManageHandrules, user?.accessToken, api])

	const { data, error, setToken } = useSSE(`handrules/${config.handrulesLobbyId}`, true);
	const [tehnic, setTehnic] = useState(false);

	useEffect(() => {
		if (canConnectSSE && user?.accessToken) {
			setToken(user.accessToken);
		}
	}, [canConnectSSE, user?.accessToken])

	useEffect(() => {
		if (!data) return;
		setTehnic(data.q[0]?.type === "T");
	}, [data])

	useEffect(() => {
		if (error) {
			console.error("SSE Error:", error);
			setApiError(true);
			setShowErrorModal(true);
		}
	}, [error]);

	return (
		<div>
			{data ? (<div className="handrulesContainer">
				<HeaderElement headerText={strings.handrules.title} />
				<HandrulesBox main={data.current} q={data.q} editMode={editMode} displayName={user.displayName} token={`Bearer ${user.accessToken}`} />
				<HandrulesButtons token={user.accessToken} editMode={editMode} lock={data.lock} />

				<TehnicLock canManage={canManageHandrules} active={tehnic} />
			</div>) : (<div>{error}</div>)}
			{canManageHandrules ? (<div onClick={() => {
				setEditMode(!editMode)
			}}
				className="adminButton">{!editMode ? (<img className="pencil" src={pencil} alt='editMode' />) : "X"}</div>) : undefined}
			{editMode ? (<div className="editMode"></div>) : undefined}

			<StandardPopup
				message="Conexiunea cu serverul are niste probleme, te rog sa dai refresh la pagina"
				isOpen={showErrorModal}
				icon={errorIcon}
				buttonsEnabled={false}
			/>
		</div>
	)
}

export default Handrules;